module.exports = __webpack_public_path__ + "static/poolwerx-dolphin-81fbc590af824ceb1aef29da4d78f194.png";